import { render, staticRenderFns } from "./interviewRecordDetail.vue?vue&type=template&id=5bd3e6c7&scoped=true"
import script from "./interviewRecordDetail.vue?vue&type=script&lang=js"
export * from "./interviewRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./interviewRecordDetail.vue?vue&type=style&index=0&id=5bd3e6c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3e6c7",
  null
  
)

export default component.exports